// import { combineReducers } from 'redux';
import { createSlice } from '@reduxjs/toolkit';
import { FETCH_USER_START, FETCH_USER_SUCCESS, FETCH_USER_FAILURE, CLEAR_USER } from './types';

const initialState = {
  msglist: [
    { sender: 'User2', text: 'Hi there!', timestamp: '2024-01-01T10:01:00.000Z' }, // User1 - пользователь
  ],
  projects: [],
  project: {},
  role: null,
  isAdmin: false,
  prompt: '',
  prompts: [],
  promptsLoading: false,
  isGitLoading: false,
  gitProgress: {
    value: 0,
    label: '',
  },
  gitTaskId: null,
  gitContextVersion: 0,
  user: {
    data: null,
    loading: false,
    error: null,
  },
};

const slice = createSlice({
  name: 'default',
  initialState,
  reducers: {
    addMsg: (state, action) => {
      state.msglist = [...state.msglist, action.payload];
    },
    setProjects: (state, action) => {
      state.projects = action.payload;
    },
    setCurrProject: (state, action) => {
      state.project = action.payload;
    },
    savePrompt: (state, action) => {
      state.prompt = action.payload;
    },
    savePrompts: (state, action) => {
      state.prompts = action.payload;
    },
    addPrompt: (state, action) => {
      state.prompts.push(action.payload);
    },
    removePrompt: (state, action) => {
      state.prompts = state.prompts.filter((prompt) => prompt.id !== action.payload);
    },
    setPromptsLoading: (state, action) => {
      state.promptsLoading = action.payload;
    },
    setCurrRole: (state, action) => {
      state.role = action.payload;
    },
    setIsAdmin: (state, action) => {
      state.isAdmin = action.payload;
    },
    setIsGitLoading: (state, action) => {
      state.isGitLoading = action.payload;
    },
    setGitProgress: (state, action) => {
      state.gitProgress = action.payload;
    },
    setGitTaskId: (state, action) => {
      state.gitTaskId = action.payload;
    },
    incrementGitContextVersion: (state) => {
      state.gitContextVersion += 1;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(FETCH_USER_START, (state) => {
        state.user.loading = true;
        state.user.error = null;
      })
      .addCase(FETCH_USER_SUCCESS, (state, action) => {
        state.user.loading = false;
        state.user.data = action.payload;
        state.user.error = null;
      })
      .addCase(FETCH_USER_FAILURE, (state, action) => {
        state.user.loading = false;
        state.user.error = action.payload;
      })
      .addCase(CLEAR_USER, (state) => {
        state.user = initialState.user;
      });
  },
});

export default slice.reducer;

// Actions

export const {
  addMsg,
  setProjects,
  setCurrProject,
  savePrompt,
  savePrompts,
  addPrompt,
  removePrompt,
  setPromptsLoading,
  setCurrRole,
  setIsAdmin,
  setIsGitLoading,
  setGitProgress,
  setGitTaskId,
  incrementGitContextVersion,
} = slice.actions;

// export const addMsg = text => async dispatch => {
//     try {
//         dispatch(add(text));
//     } catch (error) {
//         return console.error(error.message)
//     }
// };
